import { reorderArray } from './arrayFormatter';
import { getCountryName } from './countryData';
import { readableStringFormatter } from './stringFormatter';

export interface CharDataMapperConfig {
  arr: any[];
  labelKey: string;
  valueKey: string;
  column_order?: string[];
  totalRow?: boolean;
}

export const chartDataMapper = (config: CharDataMapperConfig) => {
  const { arr, labelKey, valueKey, column_order, totalRow } = config;

  const MAX = totalRow ? 6 : 8;
   // 7 for bar charts, 6 - for pie charts

  if (!arr) return [];

  // map data to label & value (for charts), + the rest item data
  const dataset = arr?.slice(0, MAX)?.map((item) => {
    return {
      ...item,
      label:
        labelKey === 'countryCode' && item?.[labelKey]
          ? getCountryName(item?.[labelKey])
          : labelKey === 'countryCode' && !item?.[labelKey]
          ? 'Unknown'
          : readableStringFormatter(item[labelKey]),
      value: item?.[valueKey],
      labelMarkType: 'square'
    };
  })
  // sort by value (desc) 
  ?.sort((a, b) => a.value < b.value ? 1 : a.value > b.value ? -1 : 0);

  // total row (for pie charts) - if items more than MAX
  if (totalRow && arr?.length > MAX) {
    const additionalTotalValue = arr.slice(MAX).reduce((sum, item) => {
      return sum + item?.[valueKey];
    }, 0);
    const key = Object.keys(arr[0]).find((key) => key.includes('percentage'));
    const additionalTotalShare = arr.slice(MAX).reduce((sum, item) => {
      return sum + item[key as string];
    }, 0);

    dataset.push({
      [key as string]: additionalTotalShare,
      label: 'Other',
      value: additionalTotalValue,
    });
  }

  // order based on column_order param
  if (column_order) {
    return reorderArray(column_order, dataset, labelKey);
  } else {
    return dataset;
  }
};
